// extracted by mini-css-extract-plugin
export var banner = "styles-module__banner___Xi2ij";
export var buttonPanel = "styles-module__buttonPanel___JauVp";
export var userImage = "styles-module__userImage___hSaZI";
export var circleIcon = "styles-module__circleIcon___MO4HO";
export var lastCircleButton = "styles-module__lastCircleButton___Kr_hj";
export var dateAndActivity = "styles-module__dateAndActivity___Zu4EI";
export var metadata = "styles-module__metadata___VB391";
export var nameAndDescription = "styles-module__nameAndDescription___KxzqT";
export var name = "styles-module__name___y3utu";
export var description = "styles-module__description___MpKa9";
export var favoriteButton = "styles-module__favoriteButton___aa8jR";